import styled from "styled-components";

export default {
    "GuideDiv": styled.div`
        display: flex;
        flex-direction: column;
        gap: 4px;
        background-color: ${({ theme }) => theme.color.grey1};
        border: 1px solid ${({ theme }) => theme.color.grey2};
        padding: 8px 12px;
        border-radius: 4px;

        & + & {
            margin-top: 8px;
        }

        & > p {
            ${({ theme }) => theme.font.extra_small};
            color: ${({ theme }) => theme.color.grey4};  
        }
    `,
}